<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="2">
                  <b-form-group label-for="month" label="Bulan">
                    <model-select
                      id="month"
                      :options="list_month"
                      v-model="month"
                      placeholder="Bulan"
                    ></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="2">
                  <b-form-group label-for="year" label="Tahun">
                    <model-select id="year" :options="list_year" v-model="year" placeholder="Tahun"></model-select>
                  </b-form-group>
                </b-col>

                <b-col sm="2">
                  <b-form-group label-for="cro" label="Karyawan">
                    <model-select id="cro" :options="list_cro" v-model="cro" placeholder="CRO"></model-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="12">
                  <b-button size="sm" variant="stack-overflow" class="mr-1 btn-brand" @click="init">
                    <i class="fa fa-search"></i>
                    <span>Filter</span>
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="12">
        <b-card class="col-sm-12 col-md-12 col-lg-12">
          <div class="h4 text-muted text-left">
            <i class="icon-graph"></i>&nbsp;Total Order
          </div>
          <div class="small text-muted text-left mb-4">
            <b-row>
              Rata2 Transaksi per Hari CRO Bulan&nbsp;
              <!-- Daftar total order periode&nbsp; -->
              <b>{{ currentMonth }} - {{ currentYear }}</b>&nbsp;
              <strong v-if="selectCro === 'all'">semua CRO</strong>
              <strong v-else>A.N {{showNameCroSelected}}</strong>
            </b-row>
            <b-row>
              Rata - Rata:&nbsp;
              <b>
                {{mean_this_month}} Order /
                <label v-if="selectCro !== 'all'">Hari</label>
                <label v-else>Bulan</label>
              </b>
            </b-row>
          </div>

          <line-example
            v-if="!loading && selectCro !== 'all'"
            :key="uniqueId('line-cro-1')"
            :line-label="total_each_day_cro.label"
            :line-data="total_each_day_cro.dataset"
            chartId="chart-line-01"
            :height="isMobile"
          ></line-example>

          <bar-example
            v-if="!loading && selectCro === 'all'"
            :key="uniqueId('bar-cro-1')"
            :bar-label="list_total_all_cro.label"
            :bar-data="list_total_all_cro.dataset"
            chartId="chart-doughnut-01"
            :height="isMobile"
          ></bar-example>

          <loading v-if="loading"></loading>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="12">
        <b-card class="col-sm-12 col-md-12 col-lg-12">
          <div class="h4 text-muted text-left">
            <i class="icon-graph"></i>&nbsp;Kinerja CRO
          </div>
          <div class="small text-muted text-left mb-4">
            <b-row>
              Berdasarkan Waktu Menyelesaikan Transaksi&nbsp;<br/>
              Rata2 Waktu Transaksi &nbsp;<strong v-if="selectCro === 'all'">semua CRO</strong><strong v-else>A.N {{showNameCroSelected}}</strong>&nbsp;Bulan&nbsp;<b>{{ currentMonth }} - {{ currentYear }}</b>&nbsp;= XX Menit XX Detik per Transaksi

              <!-- <b>{{ currentMonth }} - {{ currentYear }}</b>&nbsp;
              <strong v-if="selectCro === 'all'">semua CRO</strong>
              <strong v-else>A.N {{showNameCroSelected}}</strong> -->
            </b-row>
          </div>

          <template v-if="!loading">
          <b-row v-if="list_ranking.length > 0">
            <b-col lg="3" sm="12">
              <ul class="timeline">
                <li v-for="(value, key) in list_ranking" :key="uniqueId('rank'+key)">
                  <div
                    class="clicked"
                    v-bind:class="{ 'first-position': (key===0), 'worst-position': ((list_ranking.length > 1) && key === (list_ranking.length - 1)) }"
                    v-on:click="selectedI(value)"
                  >
                    {{value.name}}
                    <i
                      v-if="list_ranking.length > 1"
                      v-bind:class="{ 'fa fa-thumbs-o-up': (key===0), 'fa fa-thumbs-o-down': key === (list_ranking.length - 1) }"
                    ></i>
                  </div>
                  <p class="text-muted">{{value.mean_working_time}}</p>
                </li>
              </ul>
            </b-col>
            <b-col lg="9" sm="12" v-if="selectedRanking!==null">
              <div class="h4 text-muted text-left">
                <i class="fa fa-history"></i>&nbsp;Riwayat pembuatan Order ({{selectedRanking.name}})
              </div>
              <div>
                <template v-for="(value, key) in list_history[selectedRanking.employee_id]">
                  <div :key="uniqueId('history-by-date'+key)" class="history-content">
                    <label>{{key}}</label>
                    <ul class="timeline">
                      <li
                        v-for="(value, key) in list_history[selectedRanking.employee_id][key]"
                        :key="uniqueId('rank'+key)"
                      >
                        <div>
                          {{value.order_number}} <b><small class="text-muted">({{value.time_order}})</small></b>
                        </div>
                        <ul style="list-style:none; padding: 0">
                          <li class="text-muted" v-html="'<small>'+value.mean_working_time+'</mall>'"></li>
                          <!-- <li class="text-muted" v-html="'<small>b. '+value.mean_working_time_each+'</mall>'"></li> -->
                        </ul>
                        <!-- <p class="text-muted">{{value.mean_working_time}}</p>
                        <p class="text-muted">{{value.mean_working_time_each}}</p> -->
                      </li>
                    </ul>
                  </div>
                </template>
              </div>
            </b-col>
          </b-row>

          <b-row v-else>
            <b-col lg="12" sm="12">
              <div class="text-center">
                <b>{{showNameCroSelected}}</b> pada periode
                <b>{{ currentMonth }} - {{ currentYear }}</b> tidak memiliki riwayat membuat order.
              </div>
            </b-col>
          </b-row>
          </template>
          <template v-else>
            <b-row>
              <b-col lg="12" sm="12"><loading></loading></b-col>
            </b-row>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import VueNotifications from "vue-notifications";
import loading from "@/templates/Loading.vue";
import LineExample from "@/views/charts/LineExample.vue";
import DoughnutExample from "@/views/charts/DoughnutExample.vue";
import BarExample from "@/views/charts/BarExample.vue";
import { ModelSelect } from "vue-search-select";

import * as moment from "moment";

import _ from "lodash";
export default {
  name: "dashboard-performance-ro",
  components: {
    globalTable,
    Callout,
    loading,
    LineExample,
    DoughnutExample,
    BarExample,
    ModelSelect
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      list_cro: [],
      list_month: [],
      list_year: [],
      loading: true,
      selectCro: null,
      cro: "all",
      year: moment().format("YYYY"),
      month: moment().format("MM"),
      currentMonth: moment().format("MMMM"),
      currentYear: moment().format("YYYY"),
      mean_this_month: 0,
      list_total_all_cro: [],
      total_each_day_cro: [],
      list_ranking: [],
      list_history: [],
      selectedRanking: null
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  computed: {
    username() {
      return localStorage.getItem("name");
    },
    division_name() {
      return localStorage.getItem("division_name");
    },
    position_name() {
      return localStorage.getItem("position_name");
    },
    employee_id() {
      return localStorage.getItem("nik");
    },
    total_list_rank(key) {
      let te = this.list_ranking.length - 1;
      console.log(this.list_ranking.length);

      return key === te ? true : false;
    },
    showNameCroSelected() {
      let name = "";
      this.list_cro.forEach((v, k) => {
        if (v.value === this.selectCro) {
          name = v.text;
        }
      });
      return name;
    },
    isMobile: function() {
      let check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      if (check === true) {
        if (window.screen.width < 732) {
          return undefined;
        } else {
          return 100;
        }
      } else {
        return 100;
      }
    }
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    selectedI: function(a) {
      this.selectedRanking = a;
    },
    init: function() {
      this.loading = true;
      this.selectedRanking = null;
      this.currentYear = moment(this.year + "-" + this.month + "-01").format(
        "YYYY"
      );
      this.currentMonth = moment(this.year + "-" + this.month + "-01").format(
        "MMMM"
      );
      this.selectCro = this.cro;

      this.axios
        .get(
          "/web/performance/ro/calculation/" +
            this.month +
            "/" +
            this.year +
            "/" +
            this.cro +
            "/"
        )
        .then(response => {
          this.mean_this_month = response.data.global_mean;
          this.list_ranking = response.data.mean;
          this.list_history = response.data.history;
          if (this.cro === "all") {
            this.list_total_all_cro = response.data.all_cro_order;
            let temp2 = [];
            temp2.push(response.data.all_cro_order.dataset);
            this.list_total_all_cro.dataset = temp2;
            //this.total_each_day_cro = [];
          } else {
            //this.list_total_all_cro = [];
            this.total_each_day_cro = response.data.cro_total_per_day;
          }
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });

      this.dropdown();
    },
    dropdown: function() {
      this.axios
        .get("web/dropdown/dashboard-performance/")
        .then(response => {
          this.list_cro = response.data.employee;
          this.list_month = response.data.month;
          this.list_year = response.data.year;
        })
        .catch(error => {})
        .finally(() => {
          //this.loading = false;
        });
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "DashboardProfile",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
ul.timeline {
  list-style-type: none;
  position: relative;
}
ul.timeline:before {
  content: " ";
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 400;
}
ul.timeline > li {
  margin: 20px 0;
  padding-left: 20px;
}
ul.timeline > li:before {
  content: " ";
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #22c0e8;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 400;
}
ul.timeline > li .first-position {
  color: #20a8d8;
}
ul.timeline > li .worst-position {
  color: #c81912;
}

</style>